import React, { PureComponent } from "react";
import styled, { css } from "styled-components";
import { cssMainSelector } from "../../../../../lib/cssSelectors";
import SponsoredPositionContainer from "../../../../../containers/SponsoredPositionContainer";
import OfferResultsContainer from "../../../../../containers/OfferResultsContainer";
import FullComparatorLink from "../../../../FullComparatorLink";
import MobileFilterPanel from "../../../../MobileFilterPanel";
import { OFFER_TYPES } from "../../../../../constants/offerTypes";
import CreditWarning from "../../../../CreditWarning";

const Container = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    min-width: ${(p) => p.theme.generic.minWidgetWidth || "250px"};
    max-width: ${(p) => p.theme.generic.maxWidgetWidth || "950px"};
  }
`;

const ComponentWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    width: 100%;
  }
`;

const MobileFilterPanelWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    padding-bottom: ${(p) => p.theme.spacing.sm};
  }
`;

const CreditWarningWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    padding-bottom: ${(p) => p.theme.spacing.sm};
  }
`;

const resultsWrapperPadding = css`
  padding: ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.md};
`;
const ResultsWrapper = styled.div`
  ${(p) => cssMainSelector(p.theme.tdsId)} {
    background-color: ${(p) => p.theme.offerResults.blockBackgroundColor};
    ${resultsWrapperPadding};
    width: 100%;
  }
`;

class WidgetLayout extends PureComponent {
  render() {
    const {
      clientConfig,
      offerType,
      portal,
      sponsoredPositionCount,
      updateExperiment,
      updateModal,
      widgetOptions,
    } = this.props;
    const filters = clientConfig.widgetOptions[offerType].filters.mobileFilters;

    return (
      <Container>
        <ComponentWrapper>
          {filters.length > 0 && (
            <MobileFilterPanelWrapper>
              <MobileFilterPanel
                clientConfig={clientConfig}
                offerType={offerType}
              />
            </MobileFilterPanelWrapper>
          )}
          {sponsoredPositionCount > 0 && offerType === OFFER_TYPES.proposition && (
            <CreditWarningWrapper>
              <CreditWarning portal={portal} />
            </CreditWarningWrapper>
          )}
          <ResultsWrapper>
            <SponsoredPositionContainer
              clientConfig={clientConfig}
              offerType={offerType}
              portal={portal}
              updateExperiment={updateExperiment}
              updateModal={updateModal}
              widgetOptions={widgetOptions}
            />
            <OfferResultsContainer
              clientConfig={clientConfig}
              offerType={offerType}
              portal={portal}
              updateExperiment={updateExperiment}
              updateModal={updateModal}
              widgetOptions={widgetOptions}
            />
          </ResultsWrapper>
          <FullComparatorLink clientConfig={clientConfig} />
        </ComponentWrapper>
      </Container>
    );
  }
}

export default WidgetLayout;
